<div class="menu-market">
    <a mat-button [routerLink]="watchMarketplaceLink" routerLinkActive="active">Watch Marketplace</a>
    <a mat-button routerLink="/user/listings" routerLinkActive="active">My Listings</a>
    <a mat-button routerLink="/market/sell" routerLinkActive="active">List a Watch</a>
    <a mat-button routerLink="/market/request" routerLinkActive="active">Request a Watch</a>
    <a mat-button routerLink="/user/messages" routerLinkActive="active">Buy Offers</a>
</div>